export const formatPayload = (payload) => JSON.stringify(payload, null, 0);
export const isCip45ApiAvailable = (state) => {
    return window.hasOwnProperty(state.activeWallet);
};
export const getArrayLength = (balance) => balance?.getArray()?.length ?? 0;
export const getQuantityValues = (balance) => balance
    ?.getArray()
    ?.map(([, { quantity }]) => quantity?.value?.toNumber() ?? 0)
    .sort();
//# sourceMappingURL=helpers.js.map